import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 주문 추적(공장>작업주문>공정/재고 재귀 트리) — AnalysisController#getOrdersTree(백엔드는
// factoryplan/analysis/order-tracking/orders). 다른 Report처럼 { data:[...] } 래핑이 아니라
// List<OrderTreeResultDto> 배열 자체이고, 각 노드가 자기 자식을 `rows` 필드에 재귀적으로 담은
// 진짜 트리(DeliveryStatus의 treeId 경로 문자열 방식이 아님) — 프론트에서 경로 배열로 평탄화한다.
const getOrdersTree = (params) => fpApiUtil.postParams(`${ANALYSIS}/order-tracking/orders`, params);

const fpOrderTrackingService = { getOrdersTree };
export default fpOrderTrackingService;
